import React from "react";

import defaultStyle from "./SimpleScrollableLayoutView.module.scss";
import { Scrollbars } from "@jelly/ui";

export interface SimpleScrollableLayoutCoreOptions {}

export interface SimpleScrollableLayoutProps extends SimpleScrollableLayoutCoreOptions {
  children: React.ReactNode;
  style?: Record<string, string>;
}

export const SimpleScrollableLayoutView: React.FC<SimpleScrollableLayoutProps> = (
  props: SimpleScrollableLayoutProps
) => {
  const { style = defaultStyle } = props;
  return (
    <div className={style.root}>
      <Scrollbars>{props.children}</Scrollbars>
    </div>
  );
};
